import { useLocalStorage } from '../hooks/useLocalStorage';

export const useNavMenu = () => {
  const [navigationOpen, setNavigationOpen] = useLocalStorage<boolean>(true, {
    localStorageKey: 'NavMenu-Preferences',
  });

  return [navigationOpen, setNavigationOpen] as const;
};
